import axios from 'axios';

export const YK_BASE_API_URL = 'https://ykbaseapi.yugalkunj.org';

export const ykApiClient = axios.create({
  baseURL: YK_BASE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

export function normalizeApiError(error) {
  if (error?.response) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.response?.data?.title ||
      error.message;
    return {
      status: error.response.status,
      message: message || 'Request failed',
      data: error.response.data,
    };
  }

  if (error?.request) {
    return {
      status: 0,
      message: 'Network error. Please check your internet connection and try again.',
      data: null,
    };
  }

  return {
    status: 0,
    message: error?.message || 'Unexpected error',
    data: null,
  };
}
